import { VITE_ENVIRONMENTS } from "@bidbattles/bloks/config";
import { createEnv } from "@t3-oss/env-core";
import { z } from "zod/v4";

const isServer = import.meta.env.SSR || typeof window === "undefined";
const runtimeEnv = isServer ? process.env : import.meta.env;

export const env = createEnv({
	server: {
		DEV_ALLOWED_HOSTS: z
			.string()
			.default("")
			.transform((str) => str.split(","))
			.pipe(z.array(z.string())),
		DEV_API_PROXY_URL: z.url().optional(),

		BUILD_NOMINIFY: z.coerce.boolean().default(false),

		VAPID_PUBLIC_KEY: z.string().nonempty(),
	},

	/**
	 * The prefix that client-side variables must have. This is enforced both at
	 * a type-level and at runtime.
	 */
	clientPrefix: "VITE_",

	client: {
		VITE_DEV_WS_PROXY_URL: z.url().optional(),
		VITE_ENVIRONMENT: z.enum(VITE_ENVIRONMENTS).default("production"),

		VITE_RT_PROTO: z.string().default("wss"),
		VITE_HTTP_PROTO: z.string().default("https"),
		VITE_API_HOST: z.string().nonempty(),
		VITE_RT_API_HOST: z.string().nonempty(),

		VITE_MOLLIE_PROFILE_ID: z.string().nonempty().optional(),
	},

	/**
	 * What object holds the environment variables at runtime. This is usually
	 * `process.env` or `import.meta.env`.
	 */
	runtimeEnv,

	/**
	 * By default, this library will feed the environment variables directly to
	 * the Zod validator.
	 *
	 * This means that if you have an empty string for a value that is supposed
	 * to be a number (e.g. `PORT=` in a ".env" file), Zod will incorrectly flag
	 * it as a type mismatch violation. Additionally, if you have an empty string
	 * for a value that is supposed to be a string with a default value (e.g.
	 * `DOMAIN=` in an ".env" file), the default value will never be applied.
	 *
	 * In order to solve these issues, we recommend that all new projects
	 * explicitly specify this option as true.
	 */
	emptyStringAsUndefined: true,
	isServer,
});
